import { Type } from "class-transformer";
import { Location } from './location'

export class Address {
    addressID: number;
    formattedAddress: string;

    @Type(() => Location)
    location: Location;
}